import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "./lib/auth";
import { ToastProvider } from "./components/Toast";
import ProtectedRoute from "./components/ProtectedRoute";
import TabBar from "./components/TabBar";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Cashout from "./pages/Cashout";
import Inbox from "./pages/Inbox";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import HowItWorks from "./pages/HowItWorks";
import ReferAFriend from "./pages/ReferAFriend";
import Upload from "./pages/Upload";
import Surveys from "./pages/Surveys";
import More from "./pages/More";
import { installGlobalClickSound } from "./lib/sounds";
import "./App.css";

function App() {
  useEffect(() => { installGlobalClickSound(); }, []);
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/" element={<Home />} />
            <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
            <Route path="/cashout" element={<ProtectedRoute><Cashout /></ProtectedRoute>} />
            <Route path="/inbox" element={<ProtectedRoute><Inbox /></ProtectedRoute>} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/refer" element={<ProtectedRoute><ReferAFriend /></ProtectedRoute>} />
            <Route path="/surveys" element={<ProtectedRoute><Surveys /></ProtectedRoute>} />
            <Route path="/more" element={<ProtectedRoute><More /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          </Routes>
          <TabBar />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
